import { Component, OnInit } from '@angular/core';
import { FundingModule } from '@app/funding/funding.module';
import { FundingApi } from '@shared/funding/funding-api.service';
import { Moneybar } from '@shared/funding/moneybar';

@Component({
  selector: 'app-moneybar-widget',
  templateUrl: './moneybar-widget.component.html',
  styleUrls: ['./moneybar-widget.component.scss'],
  imports: [FundingModule],
})
export class MoneybarWidgetComponent implements OnInit {
  currentMoneybar!: Moneybar;

  constructor(private readonly fundingApi: FundingApi) {}

  ngOnInit(): void {
    this.fundingApi.getCurrentFunding().subscribe(result => (this.currentMoneybar = result));
  }
}
